import { render, staticRenderFns } from "./OrganizationTreeItem.vue?vue&type=template&id=f80209d4"
import script from "./OrganizationTreeItem.vue?vue&type=script&lang=js"
export * from "./OrganizationTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports